import React, {useState,useEffect} from "react";
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

const Navbar = (props: { onToggle: (arg0: boolean) => void; }) => {
    const [isToggled, setToggled] = useState(false);
    const [count, setCount] = useState('');
    const navigate = useNavigate();

    const toggle = () => {
        const newValue = !isToggled;
        setToggled(newValue);
        props.onToggle(newValue);
    };
    const handleLogout = () =>{
        toast.success("Logout Successfully")
        navigate('/');
        localStorage.clear()

    }
    useEffect(() => {
        getAllBlog()
    }, []);
    const getAllBlog = () => {

        axios
            .get(`https://gatewayapi-uat.worldtradingleagues.com/wtl/user/api/v1/signup/users/count`)
            .then((res) => {
               setCount(res.data.usersCount)

            })
            .catch(() => {
            });
    }


    return (
        <>
        <ToastContainer/>
        <header id="header" className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <p
                    className="logo d-flex align-items-center text-decoration-none"
                >
                    <img src="" alt=""/>
                    <span className="d-none d-lg-block pt-3">WTL ADMIN</span>
                </p>
                <i className="bi bi-list toggle-sidebar-btn" onClick={toggle}/>
            </div>
            {/* End Search Bar */}
            <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center">
                    <li className="nav-item dropdown">
                        <button className="nav-link nav-icon" data-bs-toggle="dropdown">
                            <i className="bi bi-bell"/>
                            <span className="badge bg-primary badge-number">{count}</span>
                        </button>
                    </li>
                    {/* End Notification Nav */}
                    <li className="nav-item dropdown">
                        {/*<a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">*/}
                        {/*    <i className="bi bi-chat-left-text"/>*/}
                        {/*    <span className="badge bg-success badge-number">3</span>*/}
                        {/*</a>*/}
                        {/* End Messages Icon */}
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages">
                            <li className="dropdown-header">
                                You have 3 new messages
                                <a href="#">
                  <span className="badge rounded-pill bg-primary p-2 ms-2">
                    View all
                  </span>
                                </a>
                            </li>
                            <li>
                                <hr className="dropdown-divider"/>
                            </li>
                            {/*<li className="message-item">*/}
                            {/*    <a href="#a">*/}
                            {/*        <img*/}
                            {/*            src=""*/}
                            {/*            alt=""*/}
                            {/*            className="rounded-circle"*/}
                            {/*        />*/}
                            {/*        <div>*/}
                            {/*            <h4>Maria Hudson</h4>*/}
                            {/*            <p>*/}
                            {/*                Velit asperiores et ducimus soluta repudiandae labore*/}
                            {/*                officia est ut...*/}
                            {/*            </p>*/}
                            {/*            <p>4 hrs. ago</p>*/}
                            {/*        </div>*/}
                            {/*    </a>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <hr className="dropdown-divider"/>*/}
                            {/*</li>*/}
                            {/*<li className="message-item">*/}
                            {/*    <a href="#a">*/}
                            {/*        <img*/}
                            {/*            src=""*/}
                            {/*            alt=""*/}
                            {/*            className="rounded-circle"*/}
                            {/*        />*/}
                            {/*        <div>*/}
                            {/*            <h4>Anna Nelson</h4>*/}
                            {/*            <p>*/}
                            {/*                Velit asperiores et ducimus soluta repudiandae labore*/}
                            {/*                officia est ut...*/}
                            {/*            </p>*/}
                            {/*            <p>6 hrs. ago</p>*/}
                            {/*        </div>*/}
                            {/*    </a>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <hr className="dropdown-divider"/>*/}
                            {/*</li>*/}
                            {/*<li className="message-item">*/}
                            {/*    <a href="#a">*/}
                            {/*        <img*/}
                            {/*            src=""*/}
                            {/*            alt=""*/}
                            {/*            className="rounded-circle"*/}
                            {/*        />*/}
                            {/*        <div>*/}
                            {/*            <h4>David Muldon</h4>*/}
                            {/*            <p>*/}
                            {/*                Velit asperiores et ducimus soluta repudiandae labore*/}
                            {/*                officia est ut...*/}
                            {/*            </p>*/}
                            {/*            <p>8 hrs. ago</p>*/}
                            {/*        </div>*/}
                            {/*    </a>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <hr className="dropdown-divider"/>*/}
                            {/*</li>*/}
                            {/*<li className="dropdown-footer">*/}
                            {/*    <a href="#">Show all messages</a>*/}
                            {/*</li>*/}
                        </ul>
                        {/* End Messages Dropdown Items */}
                    </li>
                    {/* End Messages Nav */}
                    <li className="nav-item dropdown pe-3">
                        <a
                            className="nav-link nav-profile d-flex align-items-center pe-0"
                            href="#"
                            data-bs-toggle="dropdown"
                        >
                            <img src='https://cdn-icons-png.flaticon.com/512/3135/3135715.png' alt="Profile" className="rounded-circle"/>
                            <span className="d-none d-md-block dropdown-toggle ps-2">
                Admin
              </span>
                        </a>
                        {/* End Profile Iamge Icon */}
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                <h6>Admin</h6>
                                <span>Web Designer</span>
                            </li>
                            <li>
                                <hr className="dropdown-divider"/>
                            </li>
                            {/*<li>*/}
                            {/*    <button*/}
                            {/*        className="dropdown-item d-flex align-items-center"*/}
                            {/*    >*/}
                            {/*        <i className="bi bi-person"/>*/}
                            {/*        <span>My Profile</span>*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <hr className="dropdown-divider"/>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <button*/}
                            {/*        className="dropdown-item d-flex align-items-center"*/}
                            {/*    >*/}
                            {/*        <i className="bi bi-gear"/>*/}
                            {/*        <span>Account Settings</span>*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <hr className="dropdown-divider"/>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*    <button*/}
                            {/*        className="dropdown-item d-flex align-items-center"*/}

                            {/*    >*/}
                            {/*        <i className="bi bi-question-circle"/>*/}
                            {/*        <span>Need Help?</span>*/}
                            {/*    </button>*/}
                            {/*</li>*/}
                            <li>
                                <hr className="dropdown-divider"/>
                            </li>
                            <li>
                                <button className="dropdown-item d-flex align-items-center" onClick={handleLogout}>
                                    <i className="bi bi-box-arrow-right"/>
                                    <span>Sign Out</span>
                                </button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </header>
       </>

    );
};
export default Navbar;
